import {SETTING_DEFAULTS} from '../constants/constants';

/**
 * The value a profile setting currently has, or the default its consumers
 * assume when it is unset. Used to drive the staff payment-setting dropdowns
 * so that what they display is what the backend will actually do.
 *
 * Settings are stored as strings ('true' / 'false'); an empty string counts
 * as unset because the profile API returns it for cleared keys.
 */
export const getSettingValue = (settings, key) => {
  const stored = settings && settings[key];
  if (stored !== undefined && stored !== null && stored !== '') {
    return String(stored);
  }
  return SETTING_DEFAULTS[key];
};
